var reportcard = require('./src/reportcard');

var gradebook = require('./src/gradebook');

var authenticate = require('./src/authenticate');

var history = require('./src/history');

module.exports = function (skywardURL) {
  return {
    scrapeReport: function scrapeReport(user, pass) {
      return authenticate(skywardURL)(user, pass).then(function (auth) {
        return reportcard.fetch(skywardURL)(auth);
      }).then(function (response) {
        return {
          raw: response.data,
          data: reportcard.getData(response)
        };
      });
    },
    scrapeGradebook: function scrapeGradebook(user, pass, _ref) {
      var course = _ref.course,
          bucket = _ref.bucket;
      return authenticate(skywardURL)(user, pass).then(function (auth) {
        return gradebook.fetch(skywardURL)(auth)(course, bucket);
      }).then(function (response) {
        return {
          raw: response.data,
          data: gradebook.getData(response)
        };
      });
    },
    scrapeHistory: function scrapeHistory(user, pass) {
      return authenticate(skywardURL)(user, pass).then(history.fetch(skywardURL)).then(function (response) {
        return {
          raw: response.data,
          data: history.getData(response)
        };
      });
    }
  };
};